"use client";
import React from "react";

export default function TitleBlock() {
  return (
    <div className="absolute left-8 md:left-16 top-24">
      <div className="uppercase tracking-[0.05em] text-base text-white">
        Success
      </div>
      <h2 className="mt-4 text-4xl md:text-6xl clash-font font-[500] leading-[100%]">
        The <span className="text-[#225BD4]">Konstant</span>
        <br />
        Story
      </h2>
    </div>
  );
}
